import { Component, OnInit, ViewChild } from '@angular/core';
import { ProposedPlants, CO2BetterServedReportFilters } from "../types/CO2BetterServedReport";
import { CO2ReportsService } from "../co2-report.service";
import { NotificationService } from "../../../common/component/notification/notification.service";
import { DxDataGridComponent, DxDropDownBoxComponent, DxListComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

@Component({
  selector: 'app-co2-better-served',
  templateUrl: './co2-better-served.component.html',
  styleUrls: ['./co2-better-served.component.scss']
})
export class Co2BetterServedComponent implements OnInit {

  isLoadPanelVisible = true;
  proposedPlantsData: ProposedPlants[] = [];
  plantValue: string[] = [];
  reportFilterObj: CO2BetterServedReportFilters;
  cancrossbordersdata = [];
  cancrossborders: boolean;
  trailerSize: number;
  distributionCost: number;
  numberPattern: any = /^(0|[1-9][0-9]*)$/;
  decimalPattern: any = /^\d*\.?\d*$/;
  showReport: boolean = false;
  dataSource: any;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('plantslist', { static: false }) plantslist: DxListComponent;
  @ViewChild('plantsDropDown', { static: false }) plantsDropDown: DxDropDownBoxComponent;

  constructor(private co2ReportSvc: CO2ReportsService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.cancrossbordersdata = [{ text: "True", value: true }, { text: "False", value: false }];
    this.cancrossborders = true;
    this.trailerSize = 18;
    this.distributionCost = 3.7;
    this.getAllProposedPlants();
  }

  getAllProposedPlants() {
    this.co2ReportSvc.getallproposedplants().subscribe({
      next: data => {
        this.proposedPlantsData = data;
        this.isLoadPanelVisible = false;
      }, error: error => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching all Proposed Plants.", error);
      }
    });
  }

  getCO2BetterServedReportData() {
    this.isLoadPanelVisible = true;
    this.reportFilterObj = new CO2BetterServedReportFilters(this.plantValue, this.cancrossborders, this.trailerSize, this.distributionCost);
    this.co2ReportSvc.getCO2BetterServedreportData(this.reportFilterObj).subscribe({
      next: data => {
        this.dataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'sapCustomerID',
          },
        });
        this.showReport = true;
        this.isLoadPanelVisible = false;
      }, error: error => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching CO2 Better Served Report.", error);
      }
    });
  }

  onPlantsDropDownBoxValueChanged(e) {
    this.updateSelection(this.plantslist && this.plantslist.instance);
  }

  updateSelection(plantslist) {
    if (!plantslist) return;

    if (!this.plantValue) {
      plantslist.unselectAll();
    }
  }

  onsegmentListSelectionChanged(e) {
    this.plantValue = this.plantslist.selectedItemKeys;
  }

  viewReport() {
    this.getCO2BetterServedReportData();
  }

  getSumValueOnly(arg) {
    return arg.value.toFixed(2);
  }

  getCountValueOnly(arg) {
    return arg.value;
  }

  getDollerValueOnly(arg) {
    return "$" + arg.value;
  }

  exportExcel(e){
    this.isLoadPanelVisible = true;
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');
    exportDataGrid({
      component: this.dataGrid.instance,
      worksheet: worksheet
    }).then(function () {
      workbook.xlsx.writeBuffer()
        .then(function (buffer: BlobPart) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CO2BetterServed.xlsx');
        });
    }).then(() => {
      this.isLoadPanelVisible = false;
    });

    e.cancel = true;
  }

}
